import { Store } from './Store';

export const mapStateToProps = (currentState) => currentState;

export const getState = () => Store.currentValue || {};
